import { useEffect, useRef } from "react";
import Auth from "./sdk/Auth";

const LoginCallback = () => {
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    if (Auth?.loginWithCallback) {
      Auth.loginWithCallback();
    }
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: 40 }}>
      <h2>Loading case data...</h2>
    </div>
  );
};

export default LoginCallback;